import { Link } from 'gatsby';
import React, { useContext } from 'react';
import { StickyScrollUp } from 'react-stickup';
import { useLocation } from '@reach/router'; //eslint-disable-line
import PropTypes from 'prop-types';
import useMediaQuery from '../hooks/useMediaQuery';
import { NavContext } from './NavContext';
import ScrollProgress from './ProgressBar';

NavbarContainer.propTypes = {
  children: PropTypes.object.isRequired,
};

function NavbarContainer({ children }) {
  const { mobileMenu } = useContext(NavContext);
  const { pathname } = useLocation();
  const isTablet = useMediaQuery('(max-width: 1200px)');
  return (
    <header
      className={
        pathname.startsWith('/blog') && !process.env.GATSBY_AI
          ? 'sticky-header'
          : ''
      }>
      {pathname.includes('/help') ? (
        <div className={mobileMenu ? 'header-main pos-fix' : 'header-main'}>
          <nav className="nav-container">
            <div className="flex-row justify-content-between align-items-center">
              <div
                className="header-logo"
                style={process.env.GATSBY_AI ? { margin: '0 auto' } : {}}>
                <Link to="/" className="logo-header">
                  <img
                    src="/img/algobulls-logo.svg"
                    alt="AlgoBulls logo"
                    width="130px"
                  />
                </Link>
                {pathname.startsWith('/blog') && !process.env.GATSBY_AI && (
                  <Link to="/blog" className="blog-icon">
                    Blog
                  </Link>
                )}
              </div>
              {children}
              {(!mobileMenu &&
                isTablet &&
                pathname.includes('/help') &&
                !process.env.GATSBY_AI) || (
                <NavBarButtons blogPage={pathname.startsWith('/blog')} />
              )}
            </div>
          </nav>
        </div>
      ) : (
        <StickyScrollUp style={{ zIndex: '999999999' }}>
          <div className={mobileMenu ? 'header-main pos-fix' : 'header-main'}>
            <nav className="nav-container">
              <div className="flex-row justify-content-between align-items-center">
                <div
                  className="header-logo"
                  style={process.env.GATSBY_AI ? { margin: '0 auto' } : {}}>
                  <Link to="/" className="logo-header">
                    <img
                      src="/img/algobulls-logo.svg"
                      alt="AlgoBulls logo"
                      width="130px"
                    />
                  </Link>
                  {pathname.startsWith('/blog') && !process.env.GATSBY_AI && (
                    <Link to="/blog" className="blog-icon">
                      Blog
                    </Link>
                  )}
                </div>
                {children}
                {(!mobileMenu &&
                  isTablet &&
                  pathname.startsWith('/blog') &&
                  !process.env.GATSBY_AI) || (
                  <NavBarButtons blogPage={pathname.startsWith('/blog')} />
                )}
              </div>
            </nav>
          </div>

          {/*  {(!mobileMenu && isTablet && pathname.startsWith('/blog')) || (
            <div className="floating-social">
              <a
                href="https://api.whatsapp.com/send?phone=919653415232"
                target="_blank"
                rel="noopener">
                <img src="/img/whatsapp.svg" alt="whatsapp" />
              </a>
              <a href="tel:+918069230300">
                <img src="/img/phone.svg" alt="phone" />
              </a>
              <button
                type="button"
                className="button-unstyled"
                onClick={contactPopupClick}>
                <img src="/img/email.svg" alt="email" />
              </button>
            </div>
        )} */}
          {/* {isSticky && <div style={{ height: 75 }} />} */}
          {pathname.startsWith('/blog') ? (
            <ScrollProgress className=".article-container" />
          ) : null}
        </StickyScrollUp>
      )}
    </header>
  );
}

export function NavBarButtons() {
  const { pathname } = useLocation();
  return (
    <div
      className={`mob-nav-btns ${
        process.env.GATSBY_AI ? 'abosulte-nav-btns' : ''
      }`}>
      <a
        href="https://app.algobulls.com/user/login"
        className="login-button"
        target="_blank"
        rel="noopener noreferrer">
        Login
      </a>
      <a
        href="https://app.algobulls.com/user/register"
        className={`button ${pathname.startsWith('/phoenix-copilot') ? 'button-gradiant' : ''}`}
        style={{ color: 'white' }}
        target="_blank"
        rel="noopener noreferrer">
        Sign Up
      </a>
    </div>
  );
}

export default NavbarContainer;
